.vendor-lead-step-contact-tab__container {
  height: 100%;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 32px;

  padding: 24px 0 0;
}

.vendor-lead-step-contact-tab__container .vendor-lead-step-contact-tab__container__contact {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 8px;
}

.vendor-lead-step-contact-tab__container .vendor-lead-step-contact-tab__container__header {
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

.vendor-lead-step-contact-tab__container .vendor-lead-step-contact-tab__container__delimiter {
  align-self: stretch;
  height: 4px;

  background-color: var(--color-border);

  margin-bottom: 16px;
}

.vendor-lead-step-contact-tab__container .vendor-lead-step-contact-tab__container__row {
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

.vendor-lead-step-contact-tab__container .vendor-lead-step-contact-tab__container__subrow {
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

.vendor-lead-step-contact-tab__container .vendor-lead-step-contact-tab__container__add-button {
  align-self: flex-start;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
}

@media screen and (width <= 640px) {
  .vendor-lead-step-contact-tab__container {
    flex-flow: column nowrap;
    align-items: stretch;
  }

  .vendor-lead-step-contact-tab__container .w-50 {
    width: 100% !important;
  }

  .vendor-lead-step-contact-tab__container .vendor-lead-step-contact-tab__container__row {
    flex-flow: column nowrap;
    align-items: stretch;
  }

  .vendor-lead-step-contact-tab__container .vendor-lead-step-contact-tab__container__add-button {
    align-self: unset;

    justify-content: center;
  }
}
